<div class="popup-div">
    <div class="flex justify-between items-center pb-3">
        <div class="flex gap-4 items-center">
            <div class="yellow-bar"></div>
            <h1 class="sub-text text-center">Qr Code Preview</h1>
        </div>
        <img src="../../../assets/Icons/close-icon.svg" class="close-icon" (click)="close()" style="cursor: pointer" />
    </div>
    <div class="flex flex-col justify-center items-center gap-8 p-16">
        <div #qrcodeElement>
            <qrcode [qrdata]="link" [width]="200" [errorCorrectionLevel]="'M'" renderAs="canvas"></qrcode>
        </div>
        <button class="button-submit" (click)="downloadQRCode()">Download QR Code</button>

    </div>

</div>